export const selectContractActions = state => state.contractActions;

export const selectContractActionsList = state =>
  selectContractActions(state).items;

export const selectContractActionsListCount = state =>
  selectContractActions(state).count;

export const selectContractActionsQueryOptions = state => {
  const { options } = selectContractActions(state);

  const cleanedOptions = { ...options };
  Object.keys(cleanedOptions).forEach(key => {
    if (cleanedOptions[key] === '') {
      delete cleanedOptions[key];
    }
  });

  return cleanedOptions;
};

export const selectContractActionsSummary = state =>
  selectContractActions(state).summary;
